// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"352ef94b","28":"4ef19f19","99":"0fcc1256","113":"e7104c83","125":"ce443b5b","189":"c6d34232","322":"5d67093f","352":"6370f22b","453":"71d240b3","609":"164be54e","612":"93521c78","970":"24f0b667","974":"9c74000c"}[chunkId] + ".chunk.js";
};